
import Button from "@/components/base/Button"
import HeadlineLogo from "@/components/region/passau/HeadlineLogo"
import LoginProfileButtons from "@/components/auth/LoginProfileButtons"

export default {
    name: "RegionHeader",
    components: { Button, HeadlineLogo, LoginProfileButtons },
    data: () => ({
        images: [
            require("@/assets/images/region/passau/cities/passau.jpg"),
            require("@/assets/images/region/passau/cities/vilshofen.jpg"),
            require("@/assets/images/region/passau/cities/hauzenberg.jpg"),
            require("@/assets/images/region/passau/cities/fuerstenstein.jpg"),
            require("@/assets/images/region/passau/cities/bad_griesbach.jpg"),
            require("@/assets/images/region/passau/cities/untergriesbach.jpg"),
        ],
    }),
    computed: {
        isDarkPage() {
            return (
                this.$route.name === "region-passau" ||
                this.$route.name === "region-passau-anmeldung"
            )
        },
    },
}
